import { ApiConfig } from 'src/plugins/api/declare'

const apiConfig: ApiConfig[] = [
  {
    name: 'getCollectionOrderPaged',
    method: 'POST',
    path: '/OP/OPGateway/GetCollectionOrderPaged',
    params: {},
    axiosOptions: {},
    desc: '采集通道-列表'
  },
  {
    name: 'getMnSn',
    method: 'POST',
    path: '/OP/OPGateway/GetMnSn',
    params: {},
    axiosOptions: {},
    desc: 'MSN详情'
  },
]

export default apiConfig